import { Injectable, signal } from "@angular/core"
import { CorpException } from "@corporate-tailwind/model"
import { CorpTranslateService } from "@corporate-tailwind/translation"
import { finalize, tap } from "rxjs"
import { BusinessExceptionMessage } from "src/app/shared/model/business-exception.model"
import { OrderTrackingDto } from "../../model/order-tracking.model"
import { OrderTrackingApi } from "../service/order-tracking.api"


@Injectable({ providedIn: 'root' })
export class OrderTrackingState {
    private readonly _orderTracking = signal<OrderTrackingDto | null>(null);
    private readonly _businessException = signal<BusinessExceptionMessage[] | null>(null);
    private readonly _loading = signal<boolean>(false);

    public readonly orderTracking = this._orderTracking.asReadonly();
    public readonly businessException = this._businessException.asReadonly();
    public readonly loading = this._loading.asReadonly();

    constructor(
        private _orderTrackingApi: OrderTrackingApi,
        private _corpTranslateService: CorpTranslateService
    ) {
        this._corpTranslateService.attach(this._orderTracking)
        this._corpTranslateService.attach(this._businessException) // AJOUT
    }

    load(orderCode: string, languageCode: string) {
        this._loading.set(true)

        this._orderTrackingApi.load(orderCode, languageCode)
            .pipe(
                tap(() => this._loading.set(true)),
                finalize(() => this._loading.set(false))
            )
            .subscribe({
                next: orderTracking => {
                    orderTracking = this._corpTranslateService.translate(orderTracking)
                    this._orderTracking.set(orderTracking)
                    this._businessException.set(null) // nettoyer l'exception précédente
                },
                error: (err: any) => {
                    if (err.status == 422) {
                        const problem = err.error
                        let exceptions: BusinessExceptionMessage[] = JSON.parse(problem.detail)
                        exceptions = this._corpTranslateService.translate(exceptions) // 👈 AJOUT
                        this._businessException.set(exceptions)
                    } else if (err.statusCode == 422) {
                        const problem = err as CorpException
                        let exceptions: BusinessExceptionMessage[] = JSON.parse(problem.originalError.error.detail)
                        exceptions = this._corpTranslateService.translate(exceptions) // 👈 AJOUT
                        this._businessException.set(exceptions)
                    }
                }
            })
    }

    unload() {
        this._orderTracking.set(null)
    }

    patch(changes: Partial<OrderTrackingDto>) {
        this._orderTracking.update(u => u ? { ...u, ...changes } : u)
    }

}
